const EmailSVG = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <g
          id="Group_141"
          data-name="Group 141"
          transform="translate(-380 -314)"
        >
          <g id="folder_6337661" transform="translate(382.5 316.5)">
            <path
              id="Path_501"
              data-name="Path 501"
              d="M14.132,8.379V1.961A1.462,1.462,0,0,0,12.671.5H2.934A1.462,1.462,0,0,0,1.474,1.961V8.379A1.459,1.459,0,0,0,.5,9.75v2.921a2.436,2.436,0,0,0,2.434,2.434h9.737a2.436,2.436,0,0,0,2.434-2.434V9.75a1.459,1.459,0,0,0-.974-1.371ZM2.447,1.961a.488.488,0,0,1,.487-.487h9.737a.488.488,0,0,1,.487.487V8.29H10.724a.487.487,0,0,0-.487.487,1.462,1.462,0,0,1-1.461,1.461H6.829A1.474,1.474,0,0,1,5.368,8.776a.487.487,0,0,0-.487-.487H2.447ZM14.132,12.671a1.462,1.462,0,0,1-1.461,1.461H2.934a1.462,1.462,0,0,1-1.461-1.461V9.75a.488.488,0,0,1,.487-.487H4.443a2.345,2.345,0,0,0,.664,1.226,2.381,2.381,0,0,0,1.722.722H8.776a2.439,2.439,0,0,0,2.386-1.947h2.483a.488.488,0,0,1,.487.487Z"
              fill="currentColor"
            />
            <path
              id="Path_502"
              data-name="Path 502"
              d="M4.987,4.474H6.934a.487.487,0,0,0,0-.974H4.987a.487.487,0,0,0,0,.974Z"
              transform="translate(-0.105 -0.079)"
              fill="currentColor"
            />
            <path
              id="Path_503"
              data-name="Path 503"
              d="M10.829,6.474a.487.487,0,1,0,0-.974H4.987a.487.487,0,1,0,0,.974Z"
              transform="translate(-0.105 -0.132)"
              fill="currentColor"
            />
          </g>
          <rect
            id="Rectangle_102"
            data-name="Rectangle 102"
            width="20"
            height="20"
            transform="translate(380 314)"
            fill="none"
          />
        </g>
      </svg>
    );

}

export default EmailSVG
